exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-form-submission-js": () => import("./../../../src/pages/form-submission.js" /* webpackChunkName: "component---src-pages-form-submission-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-labyrinth-js": () => import("./../../../src/pages/labyrinth.js" /* webpackChunkName: "component---src-pages-labyrinth-js" */)
}

